module.exports = __webpack_public_path__ + "img/navDataV.40ff7846.png";